import TrainingCourseCertificatePage from '../TrainingCourses/CertificatePage';
import {useTranslation} from 'react-i18next';
import usePageMeta from '../../services/page-meta';

export default function CourseCertificatePage() {
    const {t} = useTranslation();
    usePageMeta({
        title: t('courses.certificate.title', t('courses.title')),
        description: t('app.description'),
        keywords: t('app.keywords'),
    });

    return <TrainingCourseCertificatePage />;
}
